




















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import Bill from "@/models/bill/Bill";
import BillUpdateDialogBasicData from "@/components/bill/BillUpdateDialogBasicData.vue";
import {BillState, Permissions} from "@/helpers/constants";

@Component({
	components: {
		AsiCardDetailEntry,
		AsiCardDetail,
		BillUpdateDialogBasicData
	}
})
export default class BillCardBasicData extends Vue {

	@Prop({type: Object, default: null})
	public bill!: Bill | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isLocked(): boolean {
		if (this.bill === null) return true;
		return this.bill.state === BillState.locked;
	}

	@Emit('billChanged')
	public billChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
